import { defineStore } from 'pinia';
import api from '@/services/api';

export const useImposicionStore = defineStore('imposicion', {
  state: () => ({
    opciones: [],
    isLoading: false,
    opcionSeleccionada: null,
    categoriasDisponibles: [],
    familiasDisponibles: [],
    tiposDisponibles: [],
    isLoadingFiltros: false,
  }),

  actions: {
    async calcularOpciones(parametrosFormulario) {
      this.isLoading = true;
      this.opciones = [];
      this.opcionSeleccionada = null;

      try {
        const response = await api.post('/imposicion/calcular', parametrosFormulario);
        const data = response.data.data || [];
        data.forEach(Object.freeze);
        this.opciones = Object.freeze(data);
        if (this.opciones.length > 0) {
          this.opcionSeleccionada = this.opciones[0].id;
        }
      } catch (error) {
        console.error('Error calculando imposición:', error);
      } finally {
        this.isLoading = false;
      }
    },
    async obtenerFiltrosDisponibles(codigoElementoTipo) {
      if (!codigoElementoTipo) return;

      this.isLoadingFiltros = true;
      this.categoriasDisponibles = [];
      this.familiasDisponibles = [];
      this.tiposDisponibles = [];

      try {
        const response = await api.get(`/imposicion/filtros-disponibles/${codigoElementoTipo}`);

        if (response.data && response.data.status === 'success') {
          const { categorias, familias, tipos } = response.data.data;
          this.categoriasDisponibles = categorias || [];
          this.familiasDisponibles = familias || [];
          this.tiposDisponibles = tipos || [];
        }
      } catch (error) {
        console.error('Error obteniendo filtros disponibles para imposición:', error);
      } finally {
        this.isLoadingFiltros = false;
      }
    },

    seleccionarOpcion(id) {
      this.opcionSeleccionada = id;
    },
  },

  getters: {
    opcionActiva(state) {
      return state.opciones.find((o) => o.id === state.opcionSeleccionada) || null;
    },
  },
});
